import { Box } from '@mui/material';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";

var JoveDialogFooter = function JoveDialogFooter(props) {
  var children = props.children,
      className = props.className;
  return /*#__PURE__*/_jsx(Box, {
    className: clsx('flex flex-col p-4', className),
    children: children
  });
};

export default JoveDialogFooter;